<template>
  <div>
    <SignUpComponent/>
  </div>
</template>

<script>
import SignUpComponent from "@/components/LoginComponents/SignUpComponent";

export default {
  components: {SignUpComponent},
  title: 'SignUp'
}
</script>
